export const DEFAULT_TITLE_SEPARATOR = "-";

export function normalizeTitleSeparator(value: unknown): string {
  return typeof value === "string" && value.trim()
    ? value.trim()
    : DEFAULT_TITLE_SEPARATOR;
}

export function joinPageTitle(
  parts: Array<string | null | undefined>,
  separator: unknown = DEFAULT_TITLE_SEPARATOR,
): string {
  return parts.map((part) => part?.trim()).filter(Boolean)
    .join(` ${normalizeTitleSeparator(separator)} `);
}
